export enum TipoBecaExtranjero {
  ESPECIALIDADES_MEDICAS_CUBA = 'ESPECIALIDADES_MEDICAS_CUBA',
  CIENCIAS_HUMANIDADES = 'CIENCIAS_HUMANIDADES',
  ESPECIALIDADES_MEDICAS = 'ESPECIALIDADES_MEDICAS',
  CREACION_FUTURO = 'CREACION_FUTURO',
  ESTANCIA_TECNICA_JAPON = 'ESTANCIA_TECNICA_JAPON',
}
